import { Component } from '@angular/core';
import { TravelItemMinimal } from '../../../api/models';
import { TravelService } from '../../../api/services';

@Component({
  selector: 'app-leaving',
  templateUrl: './leaving.component.html',
  styleUrl: './leaving.component.scss'
})
export class LeavingComponent {

  travels: TravelItemMinimal[] = [];

  constructor(
    private travelService: TravelService
  ){ }

  ngOnInit(){
    this.getTravels();
  }

  getTravels(){
    this.travelService.travelControllerGetEarliest({
      limit: 4,
      skip: 0
    }).subscribe({
      next: (res) => {
        this.travels = res.data.list;
      }
    })
  }

}
